import React, { useState } from 'react';
import SetupScreen from './components/SetupScreen';
import ActiveTimer from './components/ActiveTimer';
import Waves from './components/Waves';
import { AnimatePresence } from 'framer-motion';

function App() {
  const [timerState, setTimerState] = useState('setup');
  const [duration, setDuration] = useState(0);
  const [reminders, setReminders] = useState([]);
  const [themeColor, setThemeColor] = useState('#4a8ccc');

  const handleStart = (
    seconds,
    customReminders = [],
    selectedColor = '#4a8ccc'
  ) => {
    setDuration(seconds);
    setReminders(customReminders);
    setThemeColor(selectedColor);
    setTimerState('running');
  };

  const handleStop = () => {
    setTimerState('setup');
    setDuration(0);
    setReminders([]);
  };

  return (
    <div
      className="flex min-h-screen flex-col overflow-hidden bg-gradient-to-br from-[#edf6fc] via-[#e4f2fb] to-[#d4eafa] font-sans selection:bg-[#b9ddf3]"
      style={{ '--theme-color': themeColor }}
    >
      <Waves color={themeColor} />

      <main className="flex w-full flex-1 items-center py-8">
        <AnimatePresence mode="wait">
          {timerState === 'setup' ? (
            <SetupScreen key="setup" onStart={handleStart} />
          ) : (
            <ActiveTimer
              key="timer"
              duration={duration}
              reminders={reminders}
              themeColor={themeColor}
              onStop={handleStop}
            />
          )}
        </AnimatePresence>
      </main>

      <footer className="relative z-10 px-4 pb-5 text-center text-sm text-[#4b789b]">
        Built with ❤️ by{' '}
        <a
          href="https://superteacher.net"
          target="_blank"
          rel="noreferrer"
          className="font-semibold text-[#245b86] underline decoration-[#8dbbd8] underline-offset-2 transition hover:text-[#397bbd]"
        >
          SuperTeacher
        </a>
      </footer>
    </div>
  );
}

export default App;